import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../services/maintenanceService';

@Component({
    selector: 'app-forecast-detail-card',
    templateUrl: './forecast-detail-card.component.html',
    styleUrls: ['./forecast-detail-card.component.css'],
    standalone: false
})
export class ForecastDetailsCardComponent implements OnInit {
  @Input() forecastDetailsMap: Map<string, any>;
  public dataLoaded = false;
  constructor(
    public maintenanceService: MaintenanceService,
    public toaster: ToastrService,
  ) {}

  ngOnInit() {
    this.dataLoaded = true;
  }

  getABSValue(value){
    return Math.abs(value);
  }

  searchTableData(searchValue: string): boolean {
    if (!this.forecastDetailsMap) {
      return false;
    }
    for (const value of this.forecastDetailsMap.values()) {
      if (value === searchValue) {
        return true;
      }
    }
    return false;
  }
}
